<template>
  <v-card v-if="!full_screen_flg">
    <v-toolbar color="white" app>
      <v-toolbar-title class="black--text">
        <router-link :to="{ name: 'home' }">
          <v-img id="header_logo" aspect-ratio="1" alt="ヘッダーロゴ" src="/emoooo.png"></v-img>
          <v-img id="header_icon" aspect-ratio="1" alt="ヘッダーロゴ" src="/emoooo_logo.png"></v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu v-model="searchBar" :close-on-content-click="false" fixed min-width="95%" auto offset-y>
          <v-btn slot="activator" icon color="grey" flat>
            <v-icon>search</v-icon>
          </v-btn>
          <v-card flat>
            <v-card-title class="caption pb-0">検索ワードを入力してください。</v-card-title>
            <v-card-actions class="pt-0">
              <search-bar @click="searchBar = false"></search-bar>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-btn flat @click="loginByTwitter" v-if="!twitterAccount.isDisplay">ログイン</v-btn>
        <v-btn v-else flat icon color="accent" @click.stop="drawer = !drawer">
          <v-avatar size="36">
            <img :src="twitterAccount.avatarImgSrc">
          </v-avatar>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-side-icon v-if="!twitterAccount.isDisplay" @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>
    <!-- drawer -->
    <v-navigation-drawer v-model="drawer" right app>
      <v-toolbar flat class="transparent" v-if="twitterAccount.isDisplay">
        <!-- ログインアカウントの表示 -->
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-img :src="twitterAccount.avatarImgSrc"></v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ twitterAccount.userName }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider v-if="twitterAccount.isDisplay"></v-divider>
      <v-list two-line dense class="pt-0">
        <template v-for="item in items">
          <v-list-tile :to="item.to" :key="item.title" active-class="primary">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <div v-if="twitterAccount.isDisplay">
          <!-- ログイン時に表示する -->
          <v-divider/>
          <template v-for="item in loginItems">
            <v-list-tile :to="item.to" :key="item.title" active-class="primary">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <template>
            <v-list-tile @click="isOpenLogoutDialog = true" active-class="primary">
              <v-list-tile-action>
                <v-icon>{{ logout.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ logout.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </div>
        <v-divider/>
        <v-subheader>コンタクト</v-subheader>
        <template v-for="contact in contacts">
          <v-list-tile :href="contact.href" target="_blank" :key="contact.title">
            <v-list-tile-action class="mr-0">
              <v-icon :color="contact.color">{{ contact.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ contact.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="isOpenLogoutDialog">
      <v-card>
        <v-card-text>ログアウトしますか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" color="grey" flat @click.stop="isOpenLogoutDialog = false">キャンセル</v-btn>
          <v-btn class="mx-2" color="accent" tile depressed @click.stop="logoutByTwitter">ログアウト</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import config from "@/components/common/config.js";
import store from "@/store.js";
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "HeaderNavigator",
  components: {
    SearchBar
  },
  data: () => ({
    full_screen_flg: store.state.full_screen_flg,
    drawer: false,
    isOpen: false,
    searchBar: false,
    twitterAccount: {
      isDisplay: store.state.twitter_account.is_login,
      avatarImgSrc: store.state.twitter_account.avatar_img_src,
      userName: store.state.twitter_account.user_name
    },
    isOpenLogoutDialog: false,
    loginItems: [
      {
        to: "/mypage",
        title: "マイページ",
        icon: "fa-user"
      }
    ],
    logout: {
      title: "ログアウト",
      icon: "fa-sign-out-alt"
    },
    items: [
      {
        to: "/",
        title: "トップ",
        icon: "fa-home"
      },
      {
        to: "/terms",
        title: "利用規約",
        icon: "fa-book"
      },
      {
        to: "/policy",
        title: "プライバシーポリシー",
        icon: "fa-key"
      }
    ],
    contacts: [
      {
        href: "https://twitter.com/emoooo_official",
        title: "Twitter",
        icon: "fab fa-twitter",
        color: "#00aced"
      }
    ]
  }),
  computed: {
    /**
     * ログイン状態の変化を検知する
     */
    changeLoginStatus() {
      return store.state.twitter_account.is_login;
    },
    getFullScreenFlg() {
      return store.state.full_screen_flg;
    }
  },
  watch: {
    changeLoginStatus() {
      this.displayTwitterAccount();
    },
    getFullScreenFlg() {
      this.full_screen_flg = store.state.full_screen_flg;
    }
  },
  methods: {
    /**
     * ログインする
     */
    loginByTwitter() {
      this.$router.push({
        name: "twitterlogin",
        query: { callbackTo: "home" }
      })
    },
    /**
     * ログアウトする
     */
    logoutByTwitter() {
      this.$store.commit("resetTwitterAccount");
      this.$store.commit("logout");
      this.isOpenLogoutDialog = false;
      // ログアウトしたらトップに戻る
      this.$router.push({ name: "home" });
    },
    /**
     * ログイン状態が変わったら、ツイッターアカウント表示を更新する
     */
    displayTwitterAccount () {
      this.twitterAccount.isDisplay = store.state.twitter_account.is_login;
      this.twitterAccount.avatarImgSrc = store.state.twitter_account.avatar_img_src;
      this.twitterAccount.userName = store.state.twitter_account.user_name;
    }
  }
};
</script>

<style scoped lang="scss">
#header_logo {
  height: 21px;
  width: 159px;
  display: inline-block;
  vertical-align: middle;
}

#header_icon {
  height: 28px;
  width: 28px;
  display: inline-block;
  margin-left: 5px;
  vertical-align: middle;
}

#header_spacer {
  height: calc(1em + 64px);
}

.dialogBtn {
  width: 100%;
}

@media screen and (max-width: 480px) {
  // mobile: 48px
  #header_logo {
    height: 11px;
    width: 83px;
    display: inline-block;
    vertical-align: middle;
  }

  #header_icon {
    height: 20px;
    width: 20px;
    display: inline-block;
    margin-left: 5px;
    vertical-align: sub;
  }

  #header_spacer {
    height: calc(1em + 48px);
  }
}

@media screen and (min-width: 896px) {
  // mobile-portrait: 56px
  #header_logo {
    height: 18px;
    width: 136px;
    display: inline-block;
    vertical-align: middle;
  }

  #header_icon {
    height: 25px;
    width: 25px;
    display: inline-block;
    margin-left: 5px;
    vertical-align: sub;
  }

  #header_spacer {
    height: calc(1em + 56px);
  }
}
</style>
